import {Feedback, FeedbackModel} from "./feedback";
import * as firebase from "firebase";
import { Gender } from 'src/models/accounts/account';

export enum Status{
    pending = "pending",
    approved = "approved",
    completed = "completed",
    rejected = "rejected",
    notCome = "notCome",
    cancelled = "cancelled",
    removed = "removed"
}

export enum Types{
    video = "video",
    voice = "voice",
    faceToFace = "faceToFace"
}

export class Appointment {
    constructor(
        public accountId: string,
        public profileUserId: string,
        public startDate: Date,
        public endDate: Date,
        public summary: string,
        public status: Status,
        public feedback: Feedback
    ) {}
}

export interface AppointmentNonLoginModel {
    name: string;
    surname: string;
    gender: Gender;
    email: string;
    phoneNumber: number;
}

export interface AppointmentModel {
     account: AppointmentNonLoginModel;
     accountId: firebase.firestore.DocumentReference;
     profileUserId: firebase.firestore.DocumentReference;
     startDate: string;
     endDate: string;
     startDateByDay: string;
     summary: string;
     status: Status;
     feedback: FeedbackModel;
     appointmentType: Types;
     profileId: firebase.firestore.DocumentReference;
     patient: PatientModel;
}


export interface PatientModel {
    diagnosis: string;
    recommended_treatment: string;
    treatment_applied: string
    recommended_drugs: string;
    createdAt: Date;
}